module.exports = __webpack_public_path__ + "img/less.3ac95f70.png";